import React from 'react';
import { Helmet } from 'react-helmet-async';
import { companyInfo } from '../data/mock';

const SITE_URL = process.env.SITE_URL || (typeof window !== 'undefined' ? window.location.origin : 'https://yourdomain.com');

export default function SEO({ title, description, pathname = '/', keywords = [], image }) {
  const pageTitle = title ? `${title} | ${companyInfo.name}` : companyInfo.name;
  const pageDesc = description || companyInfo.description;
  const url = `${SITE_URL.replace(/\/$/, '')}${pathname}`;
  const kw = Array.isArray(keywords) ? keywords.join(', ') : keywords;

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: companyInfo.name,
    description: companyInfo.description,
    telephone: companyInfo.mobile,
    email: companyInfo.email,
    address: {
      "@type": "PostalAddress",
      streetAddress: companyInfo.address,
      addressLocality: "Bhavnagar",
      addressRegion: "Gujarat",
      postalCode: "364002",
      addressCountry: "IN"
    },
    url
  };

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDesc} />
      {kw && <meta name="keywords" content={kw} />}
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDesc} />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}

      {/* Twitter */}
      <meta name="twitter:card" content={image ? 'summary_large_image' : 'summary'} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDesc} />
      {image && <meta name="twitter:image" content={image} />}

      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
